module.exports = __webpack_public_path__ + "img/ics_f_thumb-neutral-disabled.c304b99b.svg";